import styled from 'styled-components';
interface BoxProps {
  width?: string; // String - allows length unit to be specified instead of fixed.
  height?: string;
  margin?: string;
  padding?: string;
  overflow?: string;
  overflowY?: string;
  boxSizing?: 'content-box' | 'border-box';
}

export const Box = styled.div<BoxProps>`
  overflow: ${({ overflow }) => overflow || undefined};
  width: ${({ width }) => (width ? width : '80%')};
  height: ${({ height }) => (height ? height : undefined)};
  margin: ${({ margin }) => (margin ? margin : '0 auto')};
  padding: ${({ padding }) => (padding ? padding : '24px 48px')};
  border-radius: 6px;
  box-shadow: 0 1px 8px 0 ${({ theme }) => theme.colors.shadow};
  box-sizing: ${({ boxSizing }) => (boxSizing ? boxSizing : 'border-box')};
  ${({ overflowY }) => (overflowY ? `overflow-y: ${overflowY}` : undefined)};
`;
